import jsPDF from 'jspdf';

// Abtretungserklärung PDF Generator
export const generateAbtretungserklaerungPDF = async (data) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 20;
  const contentWidth = pageWidth - 2 * margin;
  let y = 20;

  // Helper function for wrapped text
  const addWrappedText = (text, x, startY, maxWidth, lineHeight = 5) => {
    const lines = doc.splitTextToSize(text, maxWidth);
    lines.forEach((line, idx) => {
      doc.text(line, x, startY + (idx * lineHeight));
    });
    return startY + (lines.length * lineHeight);
  };

  // Header
  doc.setFontSize(10);
  doc.setTextColor(100);
  doc.text('dein-gutachten-direkt.de', margin, y);
  doc.text('Möwenstr. 2, 25462 Rellingen', pageWidth - margin, y, { align: 'right' });
  y += 15;

  // Title
  doc.setFontSize(16);
  doc.setTextColor(0);
  doc.setFont(undefined, 'bold');
  doc.text('Abtretungserklärung', margin, y);
  y += 15;

  // Case Details Box
  doc.setFontSize(10);
  doc.setFont(undefined, 'normal');
  doc.setDrawColor(200);
  doc.rect(margin, y, contentWidth, 25);
  
  doc.setFont(undefined, 'bold');
  doc.text('Aktenzeichen:', margin + 5, y + 7);
  doc.text('Schadentag:', margin + 70, y + 7);
  doc.text('Schadenort:', margin + 5, y + 17);
  
  doc.setFont(undefined, 'normal');
  doc.text(data.aktenzeichen || '-', margin + 35, y + 7);
  doc.text(data.schadentag || '-', margin + 95, y + 7);
  doc.text(data.schadenort || '-', margin + 30, y + 17);
  y += 35;

  // Anspruchsteller (Claimant)
  doc.setFont(undefined, 'bold');
  doc.text('Anspruchsteller:', margin, y);
  y += 7;
  
  doc.setFont(undefined, 'normal');
  doc.setFontSize(9);
  const claimantInfo = [
    `Name: ${data.anspruchsteller_name || '-'}`,
    `Straße, Nr: ${data.anspruchsteller_strasse || '-'}`,
    `PLZ, Ort: ${data.anspruchsteller_plz || '-'} ${data.anspruchsteller_ort || ''}`,
    `Amtl. Knz.: ${data.anspruchsteller_kennzeichen || '-'}`,
    `Telefon/Mobil: ${data.anspruchsteller_telefon || '-'}`,
    `E-Mail: ${data.anspruchsteller_email || '-'}`
  ];
  claimantInfo.forEach(line => {
    doc.text(line, margin, y);
    y += 5;
  });
  y += 5;

  // Schädiger (Defendant)
  doc.setFontSize(10);
  doc.setFont(undefined, 'bold');
  doc.text('Versicherungsnehmer / Schädiger:', margin, y);
  y += 7;
  
  doc.setFont(undefined, 'normal');
  doc.setFontSize(9);
  const defendantInfo = [
    `Name: ${data.schaediger_name || '-'}`,
    `Straße, Nr: ${data.schaediger_strasse || '-'}`,
    `PLZ, Ort: ${data.schaediger_plz || '-'} ${data.schaediger_ort || ''}`,
    `Amtl. Knz.: ${data.schaediger_kennzeichen || '-'}`,
    `Versicherung: ${data.schaediger_versicherung || '-'}`,
    `Vers.-Nummer: ${data.schaediger_vers_nummer || '-'}`,
    `Schadennummer: ${data.schaediger_schadennummer || '-'}`
  ];
  defendantInfo.forEach(line => {
    doc.text(line, margin, y);
    y += 5;
  });
  y += 8;

  // Declaration Text
  doc.setFontSize(9);
  const declarationText = `Aus Anlass des oben beschriebenen Schadenfalles beauftrage ich das oben genannte Kfz-Sachverständigenbüro, ein Gutachten zur Schadenhöhe zu erstellen. Das Sachverständigenbüro berechnet sein Honorar in Anlehnung an die Schadenhöhe gemäß Honorartabelle des Sachverständigenbüros zzgl. erforderlicher Nebenkosten und zzgl. der gesetzlichen MwSt.

Ich trete hiermit meinen Schadenersatzanspruch auf Erstattung der Sachverständigenkosten in Höhe des Bruttoendbetrages der Rechnung des beauftragten Sachverständigenbüros bzw. Nettoendbetrages bei Vorsteuerabzugsberechtigung - unwiderruflich erstrangig erfüllungshalber gegen den Fahrer, den Halter und den Versicherer des unfallbeteiligten Fahrzeuges an das Kfz-Sachverständigenbüro ab.

Hiermit weise ich den regulierungspflichtigen Versicherer an, die Sachverständigenkosten unmittelbar an das von mir beauftragte Sachverständigenbüro zu zahlen.`;

  y = addWrappedText(declarationText, margin, y, contentWidth, 4.5);
  y += 10;

  // Datenschutz
  doc.setFont(undefined, 'bold');
  doc.text('Datenschutzbestimmungen', margin, y);
  y += 5;
  doc.setFont(undefined, 'normal');
  
  const datenschutzText = `Personenbezogene Daten werden im Rahmen der Erstellung des von mir beauftragten Schadengutachtens an Dritte, u. a. an die von mir beauftragte Reparaturwerkstatt und die von mir beauftragte Anwaltskanzlei sowie an den regulierungspflichtigen Versicherer zum Zwecke der Schadenregulierung weitergeleitet werden.`;
  y = addWrappedText(datenschutzText, margin, y, contentWidth, 4.5);
  y += 10;

  // New Page for checkboxes and signature
  if (y > 220) {
    doc.addPage();
    y = 20;
  }

  // Checkboxes
  doc.setFontSize(9);
  const checkboxes = [
    { checked: data.accept_agb, text: 'Ich akzeptiere die Datenschutzbestimmungen und die AGB von dein-gutachten-direkt.de.' },
    { checked: data.accept_widerruf, text: 'Ich bestätige, dass ich die Widerrufsbelehrung erhalten habe.' },
    { checked: data.accept_sofort, text: 'Ich bin einverstanden und verlange ausdrücklich, dass vor Ende der Widerrufsfrist mit der Ausführung der beauftragten Dienstleistung begonnen wird.' }
  ];

  checkboxes.forEach(cb => {
    doc.rect(margin, y - 3, 4, 4);
    if (cb.checked) {
      doc.setFont(undefined, 'bold');
      doc.text('X', margin + 0.8, y);
      doc.setFont(undefined, 'normal');
    }
    const textLines = doc.splitTextToSize(cb.text, contentWidth - 10);
    textLines.forEach((line, idx) => {
      doc.text(line, margin + 8, y + (idx * 4.5));
    });
    y += (textLines.length * 4.5) + 5;
  });

  y += 10;

  // Signature
  doc.setFont(undefined, 'bold');
  doc.text('Unterschrift Auftraggeber:', margin, y);
  y += 5;

  if (data.signature) {
    try {
      doc.addImage(data.signature, 'PNG', margin, y, 60, 25);
      y += 30;
    } catch (e) {
      console.error('Error adding signature:', e);
      y += 30;
    }
  } else {
    doc.line(margin, y + 20, margin + 80, y + 20);
    y += 25;
  }

  // Date
  doc.setFont(undefined, 'normal');
  doc.setFontSize(9);
  doc.text(`Datum: ${new Date().toLocaleDateString('de-DE')}`, margin, y);

  // Footer
  doc.setFontSize(8);
  doc.setTextColor(100);
  doc.text('Tel: 04101 - 8471160 | E-Mail: info@dein-gutachten-direkt.de | www.dein-gutachten-direkt.de', pageWidth / 2, 285, { align: 'center' });

  return doc;
};

// Vollmacht PDF Generator
export const generateVollmachtPDF = async (data) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 20;
  const contentWidth = pageWidth - 2 * margin;
  let y = 20;

  // Helper function for wrapped text
  const addWrappedText = (text, x, startY, maxWidth, lineHeight = 5) => {
    const lines = doc.splitTextToSize(text, maxWidth);
    lines.forEach((line, idx) => {
      doc.text(line, x, startY + (idx * lineHeight));
    });
    return startY + (lines.length * lineHeight);
  };

  // Header
  doc.setFontSize(10);
  doc.setTextColor(100);
  doc.text('dein-gutachten-direkt.de', margin, y);
  y += 15;

  // Title
  doc.setFontSize(18);
  doc.setTextColor(0);
  doc.setFont(undefined, 'bold');
  doc.text('Vollmacht', margin, y);
  y += 15;

  // Opening
  doc.setFontSize(11);
  doc.setFont(undefined, 'normal');
  doc.text('Hiermit erteile ich dem Rechtsanwalt', margin, y);
  y += 10;

  // Lawyer Name
  doc.setFont(undefined, 'bold');
  doc.setFontSize(12);
  if (data.anwalt_name) {
    doc.text(data.anwalt_name, margin, y);
    if (data.anwalt_kanzlei) {
      y += 6;
      doc.setFont(undefined, 'normal');
      doc.setFontSize(10);
      doc.text(data.anwalt_kanzlei, margin, y);
    }
  } else {
    doc.text('(wird von dein-gutachten-direkt.de zugewiesen)', margin, y);
  }
  y += 15;

  // Subject
  doc.setFontSize(11);
  doc.setFont(undefined, 'bold');
  doc.text('Vollmacht in der Sache:', margin, y);
  y += 8;
  
  doc.setFont(undefined, 'normal');
  doc.setFontSize(10);
  const subjectText = `${data.vollmachtgeber_name || '-'} ./. ${data.schaediger_name || 'Schädiger'} - Verkehrsunfall vom ${data.unfalldatum || '-'}`;
  y = addWrappedText(subjectText, margin, y, contentWidth, 5);
  y += 10;

  // Scope Header
  doc.setFont(undefined, 'bold');
  doc.text('Die Vollmacht umfasst die Befugnis', margin, y);
  y += 8;

  // Scope Items
  doc.setFont(undefined, 'normal');
  doc.setFontSize(9);
  const scopeItems = [
    'zur Prozessführung (u.A. nach §§ 81 ff. ZPO einschließlich der Befugnis zur Erhebung und Zurücknahme von Widerklagen)',
    'zur Vertretung in sonstigen Verfahren und bei außergerichtlichen Verhandlungen aller Art (insbesondere in Unfallsachen zur Geltendmachung von Ansprüchen gegen Schädiger, Fahrzeughalter und deren Versicherer)',
    'zur Begründung und Aufhebung von Vertragsverhältnissen und zur Abgabe einseitiger Willenserklärungen, z.B. Kündigungen',
    'zur Durchführung von Neben- und Folgeverfahren, z.B. Arrest und einstweilige Verfügungen, Kostenfestsetzungs-, Zwangsvollstreckungs- und anderer Verfahren, die den Mandatsgegenstand betreffen',
    'Zustellungen vorzunehmen und entgegenzunehmen',
    'die Vollmacht ganz oder teilweise zu übertragen (Untervollmacht)',
    'Rechtsmittel einzulegen, zurückzunehmen oder auf sie zu verzichten',
    'den Rechtsstreit oder außergerichtliche Verhandlungen durch Vergleich oder Anerkenntnis zu erledigen',
    'Geld, den Streitgegenstand, Wertsachen und Urkunden sowie die von der Gegenseite, von der Justizkasse oder von Dritten zu zahlenden und/oder zu erstattenden Beträge entgegenzunehmen.'
  ];

  scopeItems.forEach(item => {
    doc.text('•', margin, y);
    const lines = doc.splitTextToSize(item, contentWidth - 8);
    lines.forEach((line, idx) => {
      doc.text(line, margin + 5, y + (idx * 4.5));
    });
    y += (lines.length * 4.5) + 2;
  });

  y += 8;

  // Validity
  doc.setFontSize(10);
  doc.setFont(undefined, 'bold');
  doc.text('Die Vollmacht gilt für alle Instanzen.', margin, y);
  y += 12;

  // Data Privacy Checkbox
  doc.setFont(undefined, 'normal');
  doc.setFontSize(9);
  doc.rect(margin, y - 3, 4, 4);
  if (data.accept_dsgvo) {
    doc.setFont(undefined, 'bold');
    doc.text('X', margin + 0.8, y);
    doc.setFont(undefined, 'normal');
  }
  doc.text('Ich wurde auf einem gesonderten Blatt auf die Datenschutzhinweise (DSGVO)', margin + 8, y);
  y += 5;
  doc.text('hingewiesen und bin damit einverstanden.', margin + 8, y);
  y += 20;

  // Vollmachtgeber Info
  doc.setFontSize(10);
  doc.setFont(undefined, 'bold');
  doc.text('Vollmachtgeber:', margin, y);
  y += 6;
  doc.setFont(undefined, 'normal');
  doc.setFontSize(9);
  doc.text(`Name: ${data.vollmachtgeber_name || '-'}`, margin, y);
  y += 5;
  doc.text(`Adresse: ${data.vollmachtgeber_adresse || '-'}`, margin, y);
  y += 15;

  // Signature
  doc.setFontSize(10);
  doc.setFont(undefined, 'bold');
  doc.text('Unterschrift Auftraggeber:', margin, y);
  y += 5;

  if (data.signature) {
    try {
      doc.addImage(data.signature, 'PNG', margin, y, 60, 25);
      y += 30;
    } catch (e) {
      console.error('Error adding signature:', e);
      y += 30;
    }
  } else {
    doc.line(margin, y + 20, margin + 80, y + 20);
    y += 25;
  }

  // Date
  doc.setFont(undefined, 'normal');
  doc.setFontSize(9);
  doc.text(`Datum: ${new Date().toLocaleDateString('de-DE')}`, margin, y);

  return doc;
};

// Convert PDF to Blob for upload
export const pdfToBlob = (doc) => {
  return doc.output('blob');
};

// Convert PDF to base64 for preview
export const pdfToBase64 = (doc) => {
  return doc.output('datauristring');
};
